// eslint-disable-next-line import/no-anonymous-default-export
export default {
  section: {
    main: 'MAIN',
    pages: 'PAGES',
    customerCompany: 'Customer & Company',
    customerCompanyDesc: 'Customer and company management',
    infrastructure: 'Infrastructure & Payments',
    infrastructureDesc: 'Infrastructure management - Servers and domain registration firms',
    pricing: 'Pricing Definitions',
    pricingDesc: 'Pricing management - Domain and hosting price definitions',
    system: 'System',
    systemDesc: 'System management - Users, data management and system settings'
  }
};
